<script>

import players from '../assets/data/data.json'

export default {
  name: 'p2',

  data () {
    return {
      Rounds: 21,
      Visit:"Visit ",
      Profile: "'s Profile",
      Bio: "'s Bio",
      Details: "'s Details",
      Stats: "'s Stats",
      players
    }
  },
  methods: {
    showBio(who) {
        eval('$("#details' + who + 'display").slideUp(1000)');
        eval('$("#stats' + who + 'display").slideUp(1000)');
        eval('$("#bio' + who + 'display").slideDown(1000)');
        $('#stats2').removeClass('btnOn');
        $('#details2').removeClass('btnOn')
        $('#bio2').removeClass('btnOff');
        $('#bio2').addClass('btnOn');
    },
    showDetails(who) {
        eval('$("#stats' + who + 'display").slideUp(1000)');
        eval('$("#bio' + who + 'display").slideUp(1000)');
        eval('$("#details' + who + 'display").slideDown(1000)');
        $('#bio2').removeClass('btnOn');
        $('#stats2').removeClass('btnOn');
        $('#details2').removeClass('btnOff');
        $('#details2').addClass('btnOn');
    },
    showStats(who) {
        eval('$("#details' + who + 'display").slideUp(1000)');
        eval('$("#bio' + who + 'display").slideUp(1000)');
        eval('$("#stats' + who + 'display").slideDown(1000)');
        $('#bio2').removeClass('btnOn');
        $('#details2').removeClass('btnOn');
        $('#stats2').removeClass('btnOff');
        $('#stats2').addClass('btnOn');
    },
    playerProfile(url){
        open(url,"_blank")
    }
  }
}
</script>
 
 <style>
 
 </style>



  <template> 

           <div class="flip3D">
              <div class="back" v-on:click="">
                <div class="" v-for="player in players">
                <div class="playerNumber">{{player[2].jumperNumber}}</div>
                <div class="playerName"> {{player[2].firstname}} <br /> {{player[2].lastname }} <img src="../assets/images/icon-club-carl.svg" align="right" width="40" height="40" class="clublogo"></div>
                <div id="bio2display" class="innerTxt">
                <div class="playerBio">
                    <img v-bind:src="player[2].imageUrl" width="50" height="70" align="left">{{player[2].bio}}</div>
                </div>
                <div id="details2display" class="innerTxt none">
                <div class="playerBio"><strong>Player Details</strong>
                <div class="col2">
                    <div class="col">Club:</div><div class="col"> {{player[2].club}}</div>
                    <div class="col">DOB:</div><div class="col"> {{player[2].dateOfBirth}}</div>
                    <div class="col">Height:</div><div class="col"> {{player[2].height}}</div>
                    <div class="col">Position:</div><div class="col"> {{player[2].position}}</div>
                    <div class="col">Jumper:</div><div class="col"> {{player[2].jumperNumber}}</div>
                    <div class="col">Fantasy Points:</div><div class="col"> {{player[2].fantasyPoints}}</div>
                </div>
                </div>
                </div>                
                <div id="stats2display" class="innerTxt none">
                <div class="playerBio">
                    <table  class="fx"cellspacing="0" border="1" width="200">
                        <tr class="bl wh"><td>RD</td><td>KK</td><td>HB</td><td>MK</td><td>TA</td><td>SC</td></tr>
                    </table>

                    
                    <table class="tm" cellspacing="0" border="1" width="200">

                        <tr  v-for="(Round, index) in Rounds" :key="index">
                            <td> {{player[2].games[index].round}}</td>
                            <td> {{player[2].games[index].kicks}} </td>
                            <td> {{player[2].games[index].handballs}} </td>
                            <td> {{player[2].games[index].marks}} </td>
                            <td> {{player[2].games[index].tackles}} </td>
                            <td> {{player[2].games[index].score}} </td></tr> 

                    </table>
                            
                </div>
                </div>
                <div class="lowerCard">
                    <button 
                        id="bio2" 
                        class="btnOn cardButtons" 
                        v-bind:title="player[2].firstname+ Bio" 
                        v-on:click="showBio(2)">Bio</button>

                    <button 
                        id="details2" 
                        class="btnOff cardButtons" 
                        v-bind:title="player[2].firstname+ Details" 
                        v-on:click="showDetails(2)">Details</button>

                    <button 
                        id="stats2" 
                        class="btnOff cardButtons" 
                        v-bind:title="player[2].firstname+ Stats" 
                        v-on:click="showStats(2)">Stats</button>

                    <button 
                        id="pf2" 
                        class="btnOff cardButtons" 
                        v-bind:title="Visit+player[2].firstname+ Profile" 
                        v-on:click="playerProfile(player[2].playerProfileUrl)">Profile</button>
                        
                </div>
                </div>
                <audio class="audioPlayer" controls><source src="../assets/audio/carlton_blues.mp3" type="audio/mpeg"></audio>                
              </div>
              <div class="docherty fit front" v-on:click="">
              </div>
            </div>
 </template>


// WEBPACK FOOTER //
// src/components/p2.vue